import React from 'react'
import Footer from '../components/modules/Footer'
import Navbar from '../components/modules/Navbar'
import './ParticiperStyles.css'
import { Link } from 'react-router-dom'
import { useTranslation} from "react-i18next";

import { useEffect, useRef } from 'react';

import { isMobile} from 'react-device-detect';

import {BsFileArrowDown} from 'react-icons/bs'
import { Link as LinkScroll} from 'react-scroll';
import gsap from 'gsap';
function Participer() {
  const { t } = useTranslation('common');
   
  const titleRef = useRef();
  const onLoad = () =>{
    gsap.timeline().fromTo(".letter",
    {
        x: -100,
        opacity:0,
    },
    {
        x:0,
        opacity:1,
        stagger:0.33,
        delay:0.3,
    }).to('.letter',
    {
         margin: "0 0.5vw",
        fontSize: isMobile ? 50 :100,
        stagger:0.2,
        delay:0.2,
        duration:0.5
    }).to(".letter",{
        margin: "0",
        fontSize:isMobile ? 40:70,
        delay:0.8,
        duration:0.5
    })
    
}
const onLoad2 = () =>{
  gsap.timeline().fromTo(".letter2",
  {
      x: -100,
      opacity:0,
  },
  {
      x:0,
      opacity:1,
      stagger:0.33,
      delay:0.3,
  })
  
}

useEffect(()=>{
  onLoad();
onLoad2()
      },[])

  return (
    <div>
        <Navbar scroll='false' color='transparent'/>
        <div className='participer'>
          <div className='participer-home'>
            <div className='participer-title'>
            <h1 id ='title' ref={titleRef}>
                    <span className='letter'>P</span>
                    <span className='letter'>A</span>
                    <span className='letter'>R</span>
                    <span className='letter'>T</span>
                    <span className='letter'>I</span>
                    <span className='letter'>C</span>
                    <span className='letter'>I</span>
                    <span className='letter'>P</span>
                    <span className='letter'>E</span>
                    <span className='letter'>R</span>
                     </h1>
                     <h3 id='title' ref={titleRef}>
                     <span className='letter2'>A</span>
                     <span className='letter2'>U</span>
                     <span className='letter2'> </span>
                     <span className='letter2'>T</span>
                     <span className='letter2'>O</span>
                     <span className='letter2'>S</span>
                     <span className='letter2'>S</span>
                     <span className='letter2'> </span>
                     <span className='letter2'>2</span>
                     <span className='letter2'>0</span>
                     <span className='letter2'>2</span>
                     <span className='letter2'>5</span>
                     </h3>
            </div>
            <LinkScroll to='presentation-content-title' smooth={true}  offset={-10} duration={1000}> <BsFileArrowDown style={{color:'white'}} className='fleche-mazars'/></LinkScroll>
                    <div className='vague'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,288L60,288C120,288,240,288,360,266.7C480,245,600,203,720,208C840,213,960,267,1080,288C1200,309,1320,299,1380,293.3L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg>
                    </div>
          </div>
          <div className='presentation-container'>
            <div className='presentation-content-title' id='presentation-content-title'>
              <h2> {t('participer.title')}</h2>    
            </div>
            <div className='content-img' >

            </div>
            <div className='participer-btn-content' >
              <a href='https://toss-register.bds-cs.fr/register' className='btn-participate'> {t('participer.btn')}</a>
              <Link to='/tarif' className='btn-participate'> {t('participer.btn2')}</Link>
            </div>
            <div className='devenir-deleg-title'>
              <h2> {t('participer.title2')}</h2>
            </div>
            <div className='devenir-deleg-row'> 
            <div className='devenir-deleg-column'>
              <div className='devenir-deleg-subtitle'>
                <h3>{t('participer.title3')}</h3>
                <div className='line'></div>
              </div>
              <div className='devenir-deleg-content'>
                <p> {t('participer.text1')}</p>
              </div>

            </div>
            <div className='devenir-deleg-column'>
              <div className='devenir-deleg-subtitle'>
                <h3> {t('participer.title4')}</h3>
                <div className='line'></div>
              </div>
              <div className='devenir-deleg-content'>
                <p> {t('participer.text2')}</p>
                <p> {t('participer.text3')}</p>
              </div>

            </div>
            
            </div>
            <h3 style={{textAlign:'center'}}> {t('participer.text4')}</h3>
            <div  style={{display:'flex',justifyContent:'center'}}>
              <a className='btn-participate' href='mailto:dillan.reggane@student-cs.fr?subject=%5BTOSS%5D%20Devenir%20d%C3%A9l%C3%A9gation'>  {t('participer.btn3')}</a>
            </div>
            
            

          </div>
     
        </div>
        <Footer/>
    </div>
  )
}

export default Participer
